import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateInventoryTransactionStatusReduxParams } from '~types/feat/approval';

import { TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateInventoryTransactionStatusModal.module.scss';

const ConfirmUpdateInventoryTransactionStatusModal = () => {
    const isOpen = useAppSelector(state => state.gold.modals.confirmUpdateInventoryTransactionStatusModalIsOpen);
    const tempUpdateInventoryTransactionState = useAppSelector(state => state.gold.tempUpdateInventoryTransactionState);
    const isLoading = useAppSelector(state => state.gold.loadings.updateInventoryTransactionStatus);
    const error = useAppSelector(state => state.gold.errors.updateInventoryTransactionStatus);

    const getStatus = () => {
        switch (tempUpdateInventoryTransactionState.status) {
            case (TransactionStatusEnum.Cancelled): return 'Cancel Transaction';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.goldSetConfirmUpdateInventoryTransactionStatusModalIsOpen(open));
    const updateInventoryTransactionStatus = (data: TUpdateInventoryTransactionStatusReduxParams) => dispatch(combinedActions.goldUpdateInventoryTransactionStatusAttempt(data));

    const handleSubmitClick = () => {
        updateInventoryTransactionStatus(tempUpdateInventoryTransactionState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Cancel Transaction' ? Styles['confirm-cancel'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.goldResetUpdateInventoryTransactionStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()}?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    testId='inventory-transactions-cancel-button'
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    testId='inventory-transactions-cancelTransactions-status-button'
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateInventoryTransactionStatusModal;
